import React from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Col,Row } from 'reactstrap';
import { Dialog } from "primereact/dialog";

export const ModalInformation = (props) => {

    const {
        modalInformation, toggleInformation, validCode, password, handleInputChange, getInformationSpecialDiscount,validName,valid_percentage
    } = props;

    const footer = (
        <>
       <hr />
        <div className="footer-discount">
            <Button
                type="button"
                className="btn-cancel"
                color='danger'
                onClick={toggleInformation}
            >
                Cancelar
            </Button>

            <Button
                onClick={getInformationSpecialDiscount}
                className={'btn-confirm'}
            >
                <i className="fa fa-check mr-1"></i>
                Aceptar
            </Button>
        </div>
        </>
        
    );

    return (
        <Dialog
            header={'Visualizar Código'}
            visible={modalInformation}
            onHide={toggleInformation}
            className='medium-dialog'
                footer={footer}

            >

                        <div className="info-container">

                    <div className="code-card">
                        <div className="code-label">CÓDIGO DE REFERENCIA</div>
                        <div className="code-value">{String(validCode).padStart(4, "0")}</div>
                    </div>

                    <div className="info-right">

                        <div className="info-box">
                            <div className="info-title">AUTORIZADO POR</div>
                            <div className="info-value">{validName}</div>
                        </div>

                        <div className="info-row">
                            <div className="info-box small">
                                <div className="info-title">DESCUENTO</div>
                                <div className="info-value">{valid_percentage}%</div>
                            </div>

                            <div className="info-box small success">
                                <div className="info-title">ESTADO</div>
                                <div className="info-value">ACTIVO</div>
                            </div>
                        </div>

                    </div>
                </div>
        </Dialog>
    )
}
